import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://xqbatrvrzkrqrirddtpj.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhxYmF0cnZyemtycXJpcmRkdHBqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY5OTg5ODAsImV4cCI6MjEwMjU3NDk4MH0.C89eGMuav34knvhZjQnL96QTmiX4xnfszFdmUbcQv4Q';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Video {
  id: string;
  title: string;
  player_name: string;
  video_url: string;
  thumbnail_url: string | null;
  created_at: string;
}
